function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "keyboard"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 5h-16c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-10c0-1.103-.897-2-2-2zm-.003 12h-15.997v-10h16z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 9,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 16h4c.553 0 1-.447 1-1s-.447-1-1-1h-4c-.552 0-1 .447-1 1s.448 1 1 1z"
})));

var Svg056Keyboard = function Svg056Keyboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg056Keyboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/056-keyboard.ab7ec519.svg";
export { ForwardRef as ReactComponent };